var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":("tel:" + (_vm.number.replace(/[^0-9]/g, "")))}},[(!(this.$slots.default))?_c('span',[_vm._v(_vm._s(_vm.number))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }